import { gql } from '@apollo/client';

import { mediaSession } from '../fragments';

export default gql`
  mutation CreateMediaSession(
    $courseId: String!
    $subjectId: String!
    $mediaItemId: String!
    $input: CreateMediaSessionInput!
  ) {
    mediaSession(
      courseId: $courseId
      subjectId: $subjectId
      mediaItemId: $mediaItemId
      input: $input
    )
      @rest(
        type: "MediaSession"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/videos/{args.mediaItemId}/sessions"
        method: "POST"
      ) {
      ...MediaSession
    }
  }
  ${mediaSession}
`;
